/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-01-15 14:04:15
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-10-19 19:32:52
 * @FilePath: \crm-product\found\views\sfa\views\reports\redemption_promotion\form\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Form, { formCreate } from '@/found/components/form';

import ItemRespVos from './product_info.vue';
import PhotoRespVos from './photo_list.vue';

formCreate.component('ItemRespVos', ItemRespVos);
formCreate.component('PhotoRespVos', PhotoRespVos);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      formFunctionCode: 'redemption_promotion_form',
    };
  },
  created() {

  },
  methods: {
    formComplete() {
      if (this.formConfig.code === 'view') {
        const tempData = this.formConfig.row;
        this.setValue({
          ...tempData,
          photoRespVos: tempData.metadataVos || [],
        });
        if (tempData && tempData.itemRespVos && tempData.itemRespVos.length !== 0) {
          this.hiddenFields(false, ['itemRespVos', 'title3']);
        } else {
          this.hiddenFields(true, ['itemRespVos', 'title3']);
        }
        if (tempData && tempData.metadataVos && tempData.metadataVos.length !== 0) {
          this.hiddenFields(false, ['photoRespVos', 'title2']);
        } else {
          this.hiddenFields(true, ['photoRespVos', 'title2']);
        }
      }
    },
    // 设置rule
    setRule(item) {
      const v = item;
      if (v.field === 'itemRespVos') {
        v.props.value = this.formConfig.row.itemRespVos || [];
      }
      if (v.field === 'photoRespVos') {
        v.props.value = this.formConfig.row.metadataVos || [];
      }
      return v;
    },
  },
};
